import { axiosInstance } from "lib/axios";
import { getConfig, searchAPI } from "services/apis.service";

export const getCollections = async (user) => {
  const { data } = await axiosInstance.post(
    searchAPI.getCollections,
    {
    },
    {
      cache: false,
    }
  );
  return data;
};

export const getCollectionsSource = async (
  collectionId,
  collectionSourceId,
  forBookmarkPanel = false
) => {
  const { data } = await axiosInstance.post(searchAPI.getCollectionsSource, {
    collectionId: collectionId,
    collectionSourceId: collectionSourceId,
    ...(forBookmarkPanel && { forBookmarkPanel: true }),
  }, { cache: false });

  return data;
}

export const createNewCollection = async (user, name, collectionId) => {
  const requestsData = {
    collectionName: name,
    parentCollectionId: collectionId,
  };
  const { data } = await axiosInstance.post(
    searchAPI.updateCollections,
    requestsData,
    {
      cache: false,
    }
  );
  return data;
};

const getSourcePublishedDateTime = (publishedDate) => {
  if (publishedDate == null || publishedDate === "") {
    return null;
  }

  if (publishedDate instanceof Date) {
    return Number.isNaN(publishedDate.getTime())
      ? null
      : publishedDate.toISOString();
  }

  const publishedDateValue = String(publishedDate).trim();
  if (!publishedDateValue) {
    return null;
  }

  const isoDateWithoutTimezone = publishedDateValue.match(
    /^(\d{4}-\d{2}-\d{2})(?:T(\d{2}:\d{2}:\d{2}(?:\.\d+)?))?$/
  );

  if (isoDateWithoutTimezone) {
    const time = isoDateWithoutTimezone[2] || "00:00:00";
    const normalizedTime = time.includes(".") ? time : `${time}.000`;
    return `${isoDateWithoutTimezone[1]}T${normalizedTime}Z`;
  }

  const date = new Date(publishedDateValue);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
};

export const addOrUpdateBookmark = async (
  user,
  summaryInfoData,
  markdownSummary,
  collectionID_ids,
  collectionSourceId,
  markdownLevel,
  levelLoaded = false,
  summaryLoaded = false,
  level,
  isMisinformation = false,
  isAIGeneratedContent = true,
  isAIGeneratedLevel = true,
  collectionIds = null
) => {

  // The API takes the bookmark's whole membership as collectionIds; the single
  // collectionId it used to accept is redundant now that a bookmark can live in
  // several collections at once.
  const memberships =
    Array.isArray(collectionIds) && collectionIds.length > 0
      ? collectionIds
      : [collectionID_ids];

  let json_res = {
    collectionIds: memberships,
    title: summaryInfoData.title,
    sourceName: summaryInfoData.publisher,
    sourceURL: summaryInfoData.url,
    sourcePublishedDateTime: getSourcePublishedDateTime(
      summaryInfoData.utc_date_published ?? summaryInfoData.published_date
    ),
    IsSummaryAIGeneratedContent: isAIGeneratedContent,
    IsLevellingAIGeneratedContent: isAIGeneratedLevel
  };
  if (collectionSourceId) {
    json_res = { ...json_res, collectionSourceId: collectionSourceId };
  }
  if (summaryLoaded) {
    json_res.summary = markdownSummary;
  }

  if (level) {
    json_res.comprehensionLevel = level;
  }

  if (markdownLevel) {
    json_res.articleComprehension = markdownLevel;
  }

  if (isMisinformation) {
    json_res.IsMisinformationSource = true;
  }

  const { data } = await axiosInstance.post(
    searchAPI.AddUpdateCollectionsSource,
    json_res,
    {
      cache: false,
    }
  );

  return data;
};

export const saveCitation = async (
  articleData,
  id,
  user,
  citation,
  selectedStyle,
  authors,
  isDatabaseCitation = false
) => {
  // Database (EBSCO) citations are generated by the database; there is no
  // citation metadata of ours to store, only the style and the citation.
  if (isDatabaseCitation) {
    await axiosInstance.post(
      searchAPI.saveCitation,
      {
        styles: selectedStyle,
        collectionSourceId: id,
        citation: citation,
      },
      { cache: false }
    );
    return;
  }

  let json_res = {
    ...articleData,
    itemType:
      articleData.itemType?.toLowerCase() === "webpage"
        ? "webpage"
        : articleData.itemType,
    styles: selectedStyle,
    collectionSourceId: id,
    citation: citation,
    creators: authors,
  };
  await axiosInstance.post(searchAPI.saveCitation, json_res, {
    cache: false,
  });
};

export const deleteBookmark = async (user, collectionId, collectionSourceId) => {
  await axiosInstance.delete(searchAPI.deleteCollectionsSource, {
    data: {
      collectionId,
      collectionSourceId,
      isHardDelete: false,
    },
  });
};

export const getParentCollections = async (user, id) => {
  const { data } = await axiosInstance.post(
    searchAPI.getParentCollections,
    {
      parentCollectionId: id,
    },
    {
      cache: false,
    }
  );

  return data;
};
